import { Injectable } from "@angular/core";
import { Database } from './../database';
import 'rxjs/add/operator/map';

@Injectable()
export class BllKategoriler extends Database{
    eklenecek_kategoriler=[];

    constructor(){
        super("NL_Kategoriler");
    }
}


// WEBPACK FOOTER //
// ./src/providers/bll/bll-kategoriler.ts